/**
 * @generated SignedSource<<6f2ad71fb28432e41a40362bcb50ccff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastAdminDeviceListQuery$variables = Record<PropertyKey, never>;
export type StorecastAdminDeviceListQuery$data = {
  readonly store: {
    readonly id: string;
  };
  readonly storecast: {
    readonly screens: ReadonlyArray<{
      readonly activeSession: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"StorecastDeviceItem_StorecastScreen">;
    }>;
  };
};
export type StorecastAdminDeviceListQuery = {
  response: StorecastAdminDeviceListQuery$data;
  variables: StorecastAdminDeviceListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastAdminDeviceListQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Storecast",
        "kind": "LinkedField",
        "name": "storecast",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screens",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StorecastSession",
                "kind": "LinkedField",
                "name": "activeSession",
                "plural": false,
                "selections": (v1/*: any*/),
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StorecastDeviceItem_StorecastScreen"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "StorecastAdminDeviceListQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Storecast",
        "kind": "LinkedField",
        "name": "storecast",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screens",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StorecastSession",
                "kind": "LinkedField",
                "name": "activeSession",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "latencyMs",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "629c15db5c57f4c19c94754ac133e33f",
    "id": null,
    "metadata": {},
    "name": "StorecastAdminDeviceListQuery",
    "operationKind": "query",
    "text": "query StorecastAdminDeviceListQuery {\n  store {\n    id\n  }\n  storecast {\n    screens {\n      id\n      name\n      activeSession {\n        id\n      }\n      ...StorecastDeviceItem_StorecastScreen\n    }\n  }\n}\n\nfragment StorecastDeviceItem_StorecastScreen on StorecastScreen {\n  name\n  activeSession {\n    id\n    latencyMs\n  }\n}\n"
  }
};
})();

(node as any).hash = "9df181a0afbead14e6db8ddb27bf6475";

export default node;
